// Production
const config = {
    apiUrl: 'https://api.mylittlefairies.online/api/v1',
    baseUrl: 'https://api.mylittlefairies.online',
    waUrl: 'https://mylittlefairies.online/api/wa',
    BASE_URL: 'https://mylittlefairies.online',
    // apiUrl: 'http://192.168.68.202/mlf-api/api/v1',
    // baseUrl: 'http://192.168.68.202/mlf-api'
};

export default config;